export default function Clientes() {
  return (
    <div id="container" style={{ paddingTop: '2em', paddingLeft: '2em' }}>
      <img src="images/mainengine_2015_logo_comprido.jpg"
        style={{ position: 'relative', left: '4px', width: '692px', height: 'auto', zIndex: 1, textAlign: 'left' }} />
      <div id="wb_Text8" style={{ position: 'relative', left: '4px', top: '7px', width: '143px', height: '27px', zIndex: 0, textAlign: 'left' }}>
        <div id="wb_Text9" style={{ position: 'relative', left: '4px', width: '692px', height: '73px', zIndex: 1, textAlign: 'left' }}>
          <h1 className="titulo1">Nossos clientes</h1>
          <hr id="Line10" />
          <br />
          <div><span className="linha_texto">. SCMS Previdência Privada </span></div>
          <div><span className="linha_texto">. Banco Cetelem S.A.</span></div>
          <div><span className="linha_texto">. BMG Seguradora S.A.</span></div>
          <div><span className="linha_texto">. Hoje Previdência</span></div>
          <br />
          <h1 className="titulo1">Histórico clientes</h1>
          <hr id="Line10" />
          <br />
          <div><span className="linha_texto">. Banco Bradesco Financiamentos S.A.</span></div>
          <div><span className="linha_texto">. Banco Daycoval S.A.</span></div>
          <div><span className="linha_texto">. Banco BMG S.A.</span></div>
          <div><span className="linha_texto">. Banco Matone S.A.</span></div>
          <div><span className="linha_texto">. Banco Pine S.A.</span></div>
          <div><span className="linha_texto">. União Previdencial</span></div>
          <div><span className="linha_texto">. Recíproca Assistência Previdência</span></div>
        </div>
      </div>
    </div>
  )
}
